import {
  GET_THROWBACK_COUPON_REQUEST,
  GET_THROWBACK_COUPON_SUCCESS,
  GET_THROWBACK_COUPON_FAILURE
} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: null,
  isFetched: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_THROWBACK_COUPON_REQUEST:
      return { ...state, isLoading: true, isFetched: false, error: null };
    case GET_THROWBACK_COUPON_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, isFetched: true, error: null };
    case GET_THROWBACK_COUPON_FAILURE:
      return { ...state, isLoading: false, isFetched: true, error: action.payload };
    default:
      return state;
  }
};
